<template>
  <div class="UploadFilesRight pa-8">
    <v-img
      class="UploadFilesRight_icon"
      :src="'./assets/icons/protips_icon.svg'"
    />
    <div
      v-if="documentKind"
      class="UploadFilesRight_title"
    >
      {{ indicationTitle }}
    </div>
    <div
      v-if="['proof_of_address', 'proof_of_tax_address'].includes(documentKind)"
      class="UploadFilesRight_point UploadFilesRight_point--choice"
    >
      {{ $t('main.documents.indications-points.choice') }}
    </div>
    <ul class="UploadFilesRight_point-list">
      <li
        v-for="(point, pointIndex) in indicationPoints"
        :key="pointIndex"
        class="UploadFilesRight_point-item"
      >
        {{ point }}
      </li>
      <v-btn
        v-show="documentKind === DOCS.TAX_SELF_CERTIFICATION"
        text
        :href="DOCS.FATCA_FILE"
        class="theme-btn app-button-primary nice-padding mt-6"
        download
      >
        {{ $t('main.documents.wording.download-btn') }}
      </v-btn>
    </ul>
  </div>
</template>

<script>
  import { DOCS } from '@/components/ui/inputs/FileInput.const'

  export default {
    props: {
      documentKind: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        DOCS,
      }
    },
    computed: {
      indicationTitle() {
        return this.$t(`main.documents.indications-titles.${this.documentKind}`)
      },
      indicationPoints() {
        if (!this.documentKind) {
          return []
        }
        if (!this.$te(`main.documents.indications-points.${this.documentKind}`)) {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`Unknown documentKind '${this.documentKind}'`)
          }

          return []
        }

        return this.$t(`main.documents.indications-points.${this.documentKind}`)
      },
    },
  }
</script>

<style scoped lang="scss">
.UploadFilesRight {
  border: 2px solid $color-f5f6fa;
  border-radius: 0 5px 5px 0;
  background-color: $color-fafbff;
  background-image: url('../../../../assets/icons/protips_bg.svg');
  background-position: right -20% top -20%;
  background-size: 65%;
  &_icon {
    width: 80px;
  }
  &_title {
    margin-top: 3rem;
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 2rem;
    color: $color-001c4b;
  }

  &_point-list {
    list-style: none;
    margin: 0.5rem 0 5rem 0;
    padding: 0;
  }
  &_point-item {
    list-style: none;
    text-indent: 0;
    padding-left: 10px;
    &:before {
      content: '-';
      position: absolute;
      text-indent: -10px;
    }
  }
  &_point {
    font-size: 0.8rem;
    letter-spacing: 0.21px;
    line-height: 1.4rem;
    color: $color-202122;
    &--choice {
      font-weight: 600;
    }
  }
}
</style>
